<div class="custom-skeleton">
  <div [ngSwitch]="customSkeletonConfig.skeletonType">
    <ng-container
      *ngSwitchCase="'list'"
      [ngTemplateOutlet]="listTemplate"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'grid'"
      [ngTemplateOutlet]="gridTemplate"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'bar-chart'"
      [ngTemplateOutlet]="barChartTemplate"
    ></ng-container>
    <ng-container
      *ngSwitchDefault
      [ngTemplateOutlet]="defaultTemplate"
    ></ng-container>
  </div>
</div>

<ng-template #gridTemplate>
  <ng-container>
    <div nz-row nzAlign="top" class="custom-skeleton-grid">
      <nz-table
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        [nzHideOnSinglePage]="true"
        [nzTemplateMode]="true"
        [nzBordered]="true"
      >
        <thead>
          <tr>
            <th *ngFor="let col of gridData.column">
              <ng-container *ngTemplateOutlet="defaultTemplate"> </ng-container>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of gridData.row">
            <td *ngFor="let col of gridData.column">
              <ng-container *ngTemplateOutlet="defaultTemplate"> </ng-container>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </ng-container>
</ng-template>

<ng-template #listTemplate>
  <ng-container>
    <ul nz-menu [ngStyle]="listModel.styleUl">
      <li *ngFor="let rec of listModel.listData" [ngStyle]="listModel.styleLi">
        <ng-container *ngTemplateOutlet="defaultTemplate"> </ng-container>
      </li>
    </ul>
  </ng-container>
</ng-template>

<ng-template #barChartTemplate>
  <ng-container>
    <div class="bar-chart" [ngStyle]="chartModel.style">
      <div class="nz-row bar-chart-skeleton-chart">
        <div nz-col nzSpan="1" class="yaxis"></div>
        <div nz-col nzSpan="20" class="chart-body">
          <ng-container *ngFor="let rec of chartModel.data">
            <nz-skeleton
              [ngStyle]="{ width: rec + '%' }"
              [nzActive]="true"
              [nzParagraph]="false"
            ></nz-skeleton>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #defaultTemplate>
  <nz-skeleton
    [nzLoading]="customSkeletonConfig.nzLoading"
    [nzTitle]="customSkeletonConfig.nzTitle"
    [nzActive]="customSkeletonConfig.nzActive"
    [nzParagraph]="customSkeletonConfig.nzParagraph"
  >
    <ng-content></ng-content>
  </nz-skeleton>
</ng-template>
